import { getActorState as r } from "../actor.js";
import { defaultFormFieldsGetters as o } from "./defaults.js";
import { applyTranslation as t, applyDefaults as i, sortFormFields as n } from "./util.js";
var e = function e(r, i) {
    var n = (0, o[r])(i);
    return t(n);
  },
  u = function u(o, t) {
    var n,
      u,
      f = e(o, t),
      l = (null === (u = null === (n = r(t).context) || void 0 === n ? void 0 : n.formFields) || void 0 === u ? void 0 : u[o]) || {},
      v = i(f, l);
    return delete v.QR, v;
  },
  f = function f(r, o) {
    var t = u(r, o);
    return n(t);
  };
export { e as getDefaultFormFields, u as getFormFields, f as getSortedFormFields };